module.exports = __webpack_public_path__ + "static/media/xcDOT.abae6ed4.png";